module.exports = __webpack_public_path__ + "static/img/digital01.719ff2be.png";